<h3 mat-dialog-title *ngIf="data.title"  id="{{data.id}}Title">{{ data.title }}</h3>
<mat-dialog-content >
  <p id="{{data.id}}Content">{{data.body}}</p>
  <nsc-spacer size="sm"></nsc-spacer>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-raised-button color="primary" class="nsc-button" type="button" (click)="dialogRef.close(true)">Yes</button>
  <button mat-stroked-button color="primary" class="nsc-button" type="button" (click)="dialogRef.close(false)">No</button>
</mat-dialog-actions>
